import React from "react";
import { productUpdatesRequest } from "../lib/productUpdatesApi.js";
import ProductUpdateAnnouncementDialog from "./ProductUpdateAnnouncementDialog.jsx";
import { mergeAnnouncementContents, pendingMessages } from "../utils/productUpdateAnnouncementPages.js";

// Messages prepared for the next deployment open together in one window.
export default function ProductUpdatePendingMessages({ publications, committedIds, run }) {
  const [testContent, setTestContent] = React.useState(null);
  const pending = pendingMessages(publications, committedIds);
  if (!pending.length) return null;
  function move(index, direction) {
    const ids = pending.map(entry => entry.announcement_id);
    [ids[index], ids[index + direction]] = [ids[index + direction], ids[index]];
    void run(() => productUpdatesRequest("/messages/order", { method: "POST", body: { announcement_ids: ids } }), true,
      "L’ordre des annonces est enregistré pour le prochain déploiement.");
  }
  return <section className="pu-schedule-section" aria-label="Fenêtres du prochain déploiement">
    <h4>Fenêtres du prochain déploiement</h4>
    <p className="pu-stage-description">{pending.length > 1 ? "Ces annonces s’ouvriront ensemble chez les répartiteurs, dans une seule fenêtre et dans cet ordre."
      : "Cette annonce s’ouvrira chez les répartiteurs après le prochain déploiement."}</p>
    <ol className="pu-composition">{pending.map((entry, index) => <li key={entry.announcement_id}>
      <span>{entry.content.sections.flatMap(section => section.items).map(item => item.title).join(" · ")}
        <small> · {entry.audience === "all" ? "Tous les répartiteurs" : `${entry.user_ids.length} utilisateur(s)`}</small></span>
      {pending.length > 1 && <div className="pu-actions">
        <button type="button" className="pu-button" disabled={index === 0} aria-label={`Monter le message ${index + 1}`} onClick={() => move(index, -1)}>↑</button>
        <button type="button" className="pu-button" disabled={index === pending.length - 1} aria-label={`Descendre le message ${index + 1}`} onClick={() => move(index, 1)}>↓</button>
      </div>}
    </li>)}</ol>
    <div className="pu-actions"><button type="button" className="pu-button"
      onClick={() => setTestContent(mergeAnnouncementContents(pending.map(entry => entry.content)))}>Tester l'animation (local)</button></div>
    {testContent && <ProductUpdateAnnouncementDialog testMode content={testContent} onDismiss={() => setTestContent(null)} />}
  </section>;
}
